import type { Pillar } from '../contract';
import { BAND_WORD, BAND_BAR } from '../lib/oura';
import { cn } from '../lib/cn';

/**
 * Pillars render as WORDS, never scores out of anything (§4).
 * Result pillars in the brand colour, lever pillars grey, each labelled.
 */
export function PillarBars({ pillars }: { pillars: Pillar[] }) {
  return (
    <div className="flex flex-col gap-3.5">
      {pillars.map((p) => {
        const pct = Math.round((p.score / p.max) * 100);
        return (
          <div key={p.key} className="grid grid-cols-[1fr_auto] items-center gap-x-3 gap-y-1">
            <span className="text-sm font-medium text-gray-900">{p.label}</span>
            <span
              className={cn(
                'justify-self-end text-xs font-semibold',
                p.kind === 'result' ? 'text-blue-700' : 'text-gray-500',
              )}
            >
              {BAND_WORD[p.band]}
            </span>
            <div className="col-span-2 h-2 rounded-full bg-gray-100">
              <div
                className={cn(
                  'h-full rounded-full',
                  p.kind === 'result' ? 'bg-blue-500' : BAND_BAR[p.band],
                )}
                style={{ width: `${pct}%` }}
              />
            </div>
          </div>
        );
      })}
      <p className="mt-1 text-xs text-gray-400">
        Blue bars are how you show up. Grey bars are the things you can fix to move them.
      </p>
    </div>
  );
}
